export const LIVE_CHAT_SETTING = {
  'nova88': { license: '19079437' },
  'viva88': { license: '14792028' },
  'bong88': { license: '14792028' },
  'fifabet': { license: '19079437' },
  'ocean99': { license: '19079437' },
};

export default LIVE_CHAT_SETTING;
